/** Güven ve risk operasyonu tipleri — V2 Faz F. */

export interface TrustOverview {
  OpenFlags: number;
  UrgentFlags: number;
  OpenDisputes: number;
  /** SLA'sı geçmiş anlaşmazlık — operasyonun ilk baktığı sayı. */
  OverdueDisputes: number;
  PendingVerifications: number;
  /** Kalite kapısını geçemeyen tedarikçi — ürünleri aramada görünmez. */
  BelowQualityFloor: number;
}

export interface TrustSupplier {
  Id: string;
  ClientName: string | null;
  TrustTier: string;
  QualityFloorPass: boolean;
  RiskScore: number | null;
  RiskLane: string | null;
  OnboardingStatusId: number;
  OpenFlags: number;
  OpenDisputes: number;
  CardCount: number;
}

export interface FraudFlag {
  Id: string;
  EntityType: string;
  EntityId: string;
  RuleCode: string;
  Severity: string;
  Details: Record<string, any>;
  Resolved: boolean;
  Resolution: string | null;
  ResolvedAt: string | null;
  CreateTime: string;
  ClientName: string | null;
}

export interface Dispute {
  Id: string;
  ContractId: string | null;
  Reason: string;
  Description: string | null;
  AmountClaimed: number | null;
  Status: string;
  Outcome: string | null;
  SlaDueAt: string | null;
  Overdue: boolean;
  CreateTime: string;
  ClosedAt: string | null;
  ClientName: string | null;
}

export interface ListingVerification {
  Id: string;
  AssetCardId: string;
  AssetCardName: string | null;
  Status: string;
  CheckType: string;
  Findings: Record<string, any>;
  SlaDueAt: string | null;
  CreateTime: string;
  ReviewedAt: string | null;
  ClientName: string | null;
}

export const TRUST_TIERS = ["Basic", "Verified", "Trusted", "Premium"] as const;

export const SEVERITY_COLOR: Record<string, string> = {
  low: "secondary",
  medium: "info",
  high: "warning",
  critical: "danger",
};

export const DISPUTE_STATUS_COLOR: Record<string, string> = {
  open: "warning",
  investigating: "info",
  awaiting_evidence: "secondary",
  resolved: "success",
  rejected: "dark",
};
